import { useState } from "react";
import { Modal, Button } from '@prosolve/common-components-ui'
import FileUpload from '../../../sharedComponents/FileUpload';
import useDataResourceFiles from '../../../../dataHooks/useDataResourceFiles';

export default ({
  eventId,
  onClose,
  onSuccess,
}) => {

  const {
    uploadResourceFiles
  } = useDataResourceFiles();

  const [files, setFiles] = useState([]);
  const [isBusy, setIsBusy] = useState(false);

  const onClickSubmit = async () => {
    if (files && files.length > 0) {
      setIsBusy(true)
      try {
        await uploadResourceFiles(eventId, files)
      } catch (e) {
        console.log(e)
      }
      setIsBusy(false)
      onSuccess()
    }
  }

  const onFilesChanged = (filesUpdated = []) => {
    setFiles(filesUpdated)
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy || files.length < 1}>
        {'Submit'}
      </Button>
    </div>
  )

  return (
    <Modal title='Upload Resource Files' isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <FileUpload
          onFilesChanged={onFilesChanged}
        />
      </div>
    </Modal>
  )
}
